module.exports = __webpack_public_path__ + "static/media/factory_robot_arm.e6d57725.gltf";